import { Route, Routes, Navigate } from 'react-router-dom'
import { MasterLayout } from '_metronic/layout/MasterLayout'

import Error404View from 'Presentation/Views/404/View'

import DashboardRoutes from './Routes/Dashboard'
import OEMRoutes from './Routes/OEM'
import ProductsRoutes from './Routes/Products'
import BillingRoutes from './Routes/Billing'
import ProfileRoutes from './Routes/Profile'
import GeneralRoutes from './Routes/General'
import DocumentRoutes from './Routes/Document'
import MarketplaceRoutes from './Routes/Marketplace'

import PlansView from 'Presentation/Views/Plans/View'

import { useEffect } from 'react'
import { useAppStore } from 'Store/App'
import { useProfileStore } from 'Store/Profile'
import { shallow } from 'zustand/shallow'

const PrivateRoutes = () => {
	const prevPage = useAppStore(state => state.prevPage, shallow)
	const hasFetchProfile = useAppStore(state => state.hasFetchProfile, shallow)
	const getProfile = useProfileStore(state => state.getProfile, shallow)
	const getUserProfile = useProfileStore(state => state.getUserProfile, shallow)

	useEffect(() => {
		if (!hasFetchProfile) {
			getProfile()
			getUserProfile()
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	return (
		<Routes>
			<Route element={<MasterLayout />}>
				<Route
					path="auth/*"
					element={
						<Navigate to={prevPage && !prevPage.includes('auth') ? prevPage : '/dashboard'} />
					}
				/>
				<Route path="dashboard/*" element={<DashboardRoutes />} />

				<Route path="oem/*" element={<OEMRoutes />} />

				<Route path="billing/*" element={<BillingRoutes />} />

				<Route path="products/*" element={<ProductsRoutes />} />

				<Route path="profile/*" element={<ProfileRoutes />} />

				<Route path="general/*" element={<GeneralRoutes />} />

				<Route path="plans" element={<PlansView />} />

				<Route path="documents/*" element={<DocumentRoutes />} />

				<Route path="marketplace/*" element={<MarketplaceRoutes />} />
			</Route>

			{/* Page Not Found */}
			<Route path="*" element={<Error404View />} />
		</Routes>
	)
}

export { PrivateRoutes }
